import { COMMON_STYLES } from '@dehaat/dds'
import React, { ReactNode } from 'react'
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native'

export type BorderType = 'solid' | 'dashed'

export interface Step {
  icon: ReactNode
  label: ReactNode
  labelViewStyle?: StyleProp<ViewStyle>
  desc?: ReactNode
  descViewStyle?: StyleProp<ViewStyle>
  borderType?: BorderType
}

interface Props {
  steps: Step[]
}

const Stepper = ({ steps }: Props) => {
  return (
    <>
      {steps.map(
        (
          { icon, label, borderType, desc, labelViewStyle, descViewStyle },
          index,
        ) => (
          <React.Fragment key={index}>
            <View style={COMMON_STYLES.row}>
              {icon}
              <View style={[COMMON_STYLES.ml1, labelViewStyle]}>{label}</View>
            </View>
            <View
              style={[descViewStyle, borderType === 'dashed' && styles.dashed]}
            >
              {desc}
            </View>
          </React.Fragment>
        ),
      )}
    </>
  )
}

const styles = StyleSheet.create({
  dashed: {
    borderStyle: 'dashed',
  },
})

export default React.memo(Stepper)
